import { Title } from "@vshp/ui-components";
import pageHero from "../../../public/images/hero.jpg";
import cn from "classnames";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import SvedenNavigation from "../info/SvedenNavigation";

function Page({ coverImg, title, intro, isWidthSmall = false, children, isExtraBlock = false, extraContent, isWysiwyg = true }) {
  const { asPath } = useRouter();
  const currentPath = asPath.split(/[?#]/)[0];
  const pageBlockInnerClass = cn({
    wysiwyg: isWysiwyg,
    page__text: isWidthSmall,
    "page__block-body_small": isWidthSmall,
  });

  const bg = coverImg ? coverImg : pageHero;

  return (
    <>
      <div className="page__header">
        <Image className="page__header-cover" src={bg} alt={title} placeholder="blur" />
        <div className="page__header-body page__header-body_center">
          <Title decor={false} className="page__header-title">
            {title}
          </Title>
          {intro && <div className="page__header-intro" dangerouslySetInnerHTML={{ __html: intro }}></div>}
        </div>
      </div>
      <div className="page__blocks">
        <div className={pageBlockInnerClass}>
          {currentPath.startsWith("/sveden/") && <SvedenNavigation />}
          {children}
          {currentPath === "/sveden/grants" && (
            <section className="page__block" style={{ marginTop: 32 }}>
              <h2>Общежитие и интернат</h2>
              <p><Link href="/sveden/objects">Сведения о наличии общежития, интерната и условиях проживания</Link> опубликованы в разделе «Материально-техническое обеспечение и оснащённость образовательного процесса».</p>
            </section>
          )}
        </div>

        {isExtraBlock && <div className="page__block">{extraContent}</div>}
      </div>
    </>
  );
}

export default Page;
